import { FileTypes } from '../../constants';
import { AudioFileIcon } from 'foundations-assets/icons/components/AudioFileIcon';
import { ExcelFileIcon } from 'foundations-assets/icons/components/ExcelFileIcon';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { InsertImageIcon } from 'foundations-assets/icons/components/InsertImageIcon';
import { PdfFileIcon } from 'foundations-assets/icons/components/PdfFileIcon';
import { PowerPointFileIcon } from 'foundations-assets/icons/components/PowerPointFileIcon';
import { VideoFileIcon } from 'foundations-assets/icons/components/VideoFileIcon';
import { WordFileIcon } from 'foundations-assets/icons/components/WordFileIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const WordExtensions = ['doc', 'docx'];
export const ExcelExtensions = ['xls', 'xlsx', 'csv'];
export const PowerPointExtensions = ['ppt', 'pptx'];
export function FileTypeIcon({
  extension,
  fileType,
  size = '800',
  color
}) {
  const iconSize = size;
  switch (fileType) {
    case FileTypes.AUDIO:
      return /*#__PURE__*/_jsx(AudioFileIcon, {
        size: iconSize,
        color: color
      });
    case FileTypes.MOVIE:
      return /*#__PURE__*/_jsx(VideoFileIcon, {
        size: iconSize,
        color: color
      });
    case FileTypes.DOCUMENT:
      if (extension === 'pdf') {
        return /*#__PURE__*/_jsx(PdfFileIcon, {
          size: iconSize,
          color: color
        });
      } else if (WordExtensions.includes(extension)) {
        return /*#__PURE__*/_jsx(WordFileIcon, {
          size: iconSize,
          color: color
        });
      } else if (ExcelExtensions.includes(extension)) {
        return /*#__PURE__*/_jsx(ExcelFileIcon, {
          size: iconSize,
          color: color
        });
      } else if (PowerPointExtensions.includes(extension)) {
        return /*#__PURE__*/_jsx(PowerPointFileIcon, {
          size: iconSize,
          color: color
        });
      }
      return /*#__PURE__*/_jsx(FileIcon, {
        size: iconSize,
        color: color
      });
    case FileTypes.IMG:
      return /*#__PURE__*/_jsx(InsertImageIcon, {
        size: iconSize,
        color: color
      });
    default:
      return /*#__PURE__*/_jsx(FileIcon, {
        size: iconSize,
        color: color
      });
  }
}